export const FooterLinks = [
  //   { title: "© 2000-2026 Manchester Economic Forecasting Ltd", subLinks: [] },

  {
    title: "Terms & Policy",
    subLinks: [
      { name: "Service Terms and Conditions", link: "/about/terms-and-conditions" },
//      { name: "Service Terms and Conditions", link: "https://www.mef-uk.com/about/terms-and-conditions.jsx"  },      
//      { name: "Privacy Policy + Cookies Policy", link: "/" },
//      { name: "Copyright Notice + Disclaimer", link: "/" },
//      { name: "10461013 -Reg'd in England & Wales", link: "" },
    ],
  },
  // {
  //   title: "Social Media",
  //   subLinks: [
  //     { name: "LinkedIn", link: "/" },
  //     { name: "Twitter", link: "/" },
  //     { name: "Facebook", link: "/" },
  //     { name: "YouTube", link: "" },
  //     { name: "WeChat", link: "" },
  //   ],
  // },
  {
    title: "About Us",
    subLinks: [
      { name: "Personnel", link: "/team/model-team" },
//      { name: "History/Awards", link: "/" },
//      { name: "Associations", link: "/" },
//      { name: "YouTube", link: "" },
//      { name: "Company Info & Registration", link: "" },
//        { name: "10461013 -Reg'd in England & Wales", link: "" },
    ],
  },

  {
    title: "Contacts",
    subLinks: [
      {  name: "Scenarios-Macro/Emissions ",   link: `/subscribe/${"scenarios-subscribe"}`,  },
      {  name: "Modelling-Macro/Emissions",    link: `/subscribe/${"bespoke-modelling-subscribe"}`,  },
      {  name: "Finance/Portfolio Modelling",  link: `/subscribe/${"portfolio-subscribe"}`,  },
      {  name: "Education/Apps", 	       link: `/subscribe/${"education-subscribe"}`,  },
    ],
  },
];
